import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { PIPELINES_SERVICE_KEY } from './pipelinesEnum.js';

export default getGetterTypesForService(PIPELINES_SERVICE_KEY);
